/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   LT Ratings bizo
 */

import { Bizo, autoclass } from './base'
import type { Ratings as RatingsType, RawRatings } from './ratings.type'

export const Ratings: typeof RatingsType = autoclass<RatingsType, RawRatings>(
  'Ratings',
  class Ratings extends Bizo<RatingsType, RawRatings> {},
  {
    category0: 'category_0',
    category1: 'category_1',
    category2: 'category_2',
    category3: 'category_3',
    category4: 'category_4',
    category5: 'category_5',
  }
)

export type Ratings = RatingsType
